import { Component, forwardRef, Inject, Input, OnInit } from "@angular/core";
import { isOnline } from "../../common/setup";
import { TicketItem } from "../../model";
import { AuthenticationService } from "../../service/authentication.service";
import { ContextService } from "../../service/context.service";
import { TicketService } from "../../service/ticket.service";

@Component({
    selector: 'ticket-item-details',
    template: require('./ticket-item-details.component.html'),
    styles: [`
        .ticket-item-date {
            color: #757575;
            font-size: 12px;
        }
        .ticket-item-box {
            background-color: #F5F5F5;
            font-size: 16px;
            padding: 10px;
            gap: 8px;
            border-radius: 4px;
            width: 100%;
        }
        .ticket-attachment-container {
            height: 40px;
            background-color: #000000;
        }
        .ticket-attachment-preview-image {
            width: 100%;
            height: 100%;
            max-width: 40px;
            object-fit: contain;
        }
    `]
})
export class TicketItemDetailsComponent implements OnInit {

    @Input() item: TicketItem;

    isCurrentUser: boolean;
    timezone: string;
    locale: string;
    newStyleManagerEnabled: boolean;

    constructor(
        @Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService,
        @Inject(forwardRef(() => ContextService)) private contextService: ContextService,
        @Inject(forwardRef(() => TicketService)) private ticketService: TicketService
    ) { }

    ngOnInit(): void {
        this.isCurrentUser = this.item.userId == this.authenticationService.getUser().id;
        this.timezone = this.contextService.getTimezone();
        this.locale = this.authenticationService.getLocale();
        this.newStyleManagerEnabled = this.authenticationService.isNewStyleManagerEnabled();
    }

    downloadAttachment(): void {
        this.ticketService.downloadAttachment(this.item.attachment);
    }

    isOnline(): boolean {
        return isOnline();
    }
}